import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useForm } from '@/form/useForm.ts';

export const AncestrySummaryFormZA = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['ancestry'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  //  tongueMother, tongueFather

  const countryFatherField = addReqiredMessage({
    field: s.ancestry.fields.find(({ name }) => name === 'countryFather'),
    message: s.dataSummary.requiredMessage!,
  });
  const countryFatherLabel = translate(countryFatherField?.label);
  const countryFatherValue =
    translate(countryFatherField?.options?.find(({ value }) => value === getFieldValue('countryFather'))?.label) ||
    getFieldValue('countryFather');

  const ethnicityFatherField = s.ancestry.fields.find(({ name }) => name === 'ethnicityFather');
  const ethnicityFatherLabel = translate(ethnicityFatherField?.label);
  const ethnicityFatherValue =
    translate(ethnicityFatherField?.options?.find(({ value }) => value === getFieldValue('ethnicityFather'))?.label) ||
    getFieldValue('ethnicityFather');

  const countryMotherField = addReqiredMessage({
    field: s.ancestry.fields.find(({ name }) => name === 'countryMother'),
    message: s.dataSummary.requiredMessage!,
  });
  const countryMotherLabel = translate(countryMotherField?.label);
  const countryMotherValue =
    translate(countryMotherField?.options?.find(({ value }) => value === getFieldValue('countryMother'))?.label) ||
    getFieldValue('countryMother');

  const ethnicityMotherField = s.ancestry.fields.find(({ name }) => name === 'ethnicityMother');
  const ethnicityMotherLabel = translate(ethnicityMotherField?.label);
  const ethnicityMotherValue =
    translate(ethnicityMotherField?.options?.find(({ value }) => value === getFieldValue('ethnicityMother'))?.label) ||
    getFieldValue('ethnicityMother');

  return (
    <div className="summary-card" data-cy={'summary-form-ancestry'}>
      <h2>{translate(s.dataSummary.titles?.ancestry)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{countryFatherLabel} (Father)</div>
        <div className={'value'}>
          {!editMode && countryFatherValue}
          {editMode && <EditDataField field={countryFatherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{ethnicityFatherLabel} (Father)</div>
        <div className={'value'}>
          {!editMode && ethnicityFatherValue}
          {editMode && <EditDataField field={ethnicityFatherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{countryMotherLabel} (Mother)</div>
        <div className={'value'}>
          {!editMode && countryMotherValue}
          {editMode && <EditDataField field={countryMotherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{ethnicityMotherLabel} (Mother)</div>
        <div className={'value'}>
          {!editMode && ethnicityMotherValue}
          {editMode && <EditDataField field={ethnicityMotherField!} slideId={'ancestry'} />}
        </div>
      </div>
    </div>
  );
};
